// removed by extract-text-webpack-plugin
module.exports = {"searchForm":"search_searchForm_1cfje"};


//////////////////
// WEBPACK FOOTER
// ./src/components/regulatoryStatistical/index/riskHint/announcement/search.scss
// module id = 1567
// module chunks = 0